import { Option } from '@/components/ui/Autocomplete/Autocomplete.types'
import React from 'react'
import { secretsQueries } from '@/features/secrets'
import { useQuery } from '@tanstack/react-query'
import { SecretTemplateRequirement } from '@/features/templates'

export const useSelectOptions = (projectId: number): Option[] => {
  const { data: secrets } = useQuery(secretsQueries.list(projectId))

  return React.useMemo(() => {
    return (
      secrets?.map((secret) => ({
        label: secret.name,
        value: secret.slug,
      })) ?? []
    )
  }, [secrets])
}

export const useSecretRequirementDescription = (requirement: SecretTemplateRequirement) =>
  requirement.description ||
  'Select or create a secret value to securely store passwords and other sensitive information. This will ensure that your data remains protected.'
